export const branchMetaData = {
  hubCounter: {
    displayName: "Amazon Hub Counter"
  },
  dpd: {
    displayName: "DPD"
  }
}
